import comp from '../components/barrel';
import U from '../js/utils';

export default {
  async prepare() {
    this.recipe.methods.push(await O.mPOST('communal/languages'));
    this.recipe.methods.push(await O.mPOST('communal/provinces'));
    this.recipe.methods.push(await O.mPOST('communal/marketers'));
    this.recipe.methods.push(await O.mPOST('users/get-advisor-list'));
    this.recipe.methods.push(await O.mPOST('communal/roles'));
    this.recipe.methods.push(await O.mPOST('communal/titles'));
    this.recipe.methods.push(await O.mPOST('communal/div-branches'));
    this.recipe.methods.push(await O.mPOST('communal/org-branches'));
    this.recipe.methods.push(await O.mPOST('communal/divisions'));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(res) {
    this.titleData = res['communal/titles'].data;
    this.roleData = res['communal/roles'].data;
    this.divBranchesData = res['communal/div-branches'].data;
    this.orgBranchesData = res['communal/org-branches'].data;
    this.advisorList = res['users/get-advisor-list'].data;
    this.marketersData = res['communal/marketers'].data.map((marketer) => ({...marketer, fullName: `${marketer.f_name} ${marketer.s_name}`}));
    this.divisionsData = res['communal/divisions'].data.divisions;
    // this.orgData = res['communal/organisations'].data.organisations;

    const userForm = U.id('user-form');
    userForm.innerHTML = '';

    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');
    grid1.id = 'newUser';
    const mainDiv = U.divAtt('div', 'id', 'mainDiv');

    // ================================================
    // OFFICE DETAILS
    const officeHeading = U.divAtt('h6', 'class', 'mt-3');
    officeHeading.innerHTML = 'Office detail: ';
    grid1.appendChild(officeHeading);

    const gridOD = U.divAtt('div', 'class', 'res-grid-cols-3');
    const roleDD = await comp.select_v2({elID: 'roleSelect', ddData: this.roleData, valueDataName: 'role_uuid', textDataName: 'short_text', labelName: 'Role', requiredYN: 1, onchange: 'thsPage.configForm()'});
    gridOD.appendChild(roleDD);
    grid1.appendChild(gridOD);
    grid1.appendChild(mainDiv);

    userForm.appendChild(grid1);
  },

  async buildMainPage({pdfWillOnly}) {
    const newUser = U.id('mainDiv');
    newUser.innerHTML = '';

    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');

    const gridOD3 = U.divAtt('div', 'class', 'res-grid-cols-3');
    const activeYN = await comp.toggle_v2({elID: 'ativeYN', isChecked: true, labelName: 'Active'});
    const pdfWillOnlyTgle = await comp.toggle_v2({elID: 'pdfWillOnly', isChecked: true, labelName: 'PDF will only'});
    !pdfWillOnly && pdfWillOnlyTgle.classList.add('hide');

    const companyDiv = U.divAtt('div', 'id', 'companyDiv');
    const advisorDiv = U.divAtt('div', 'id', 'advisorDiv');
    const supportDiv = U.divAtt('div', 'id', 'supportDiv');

    gridOD3.appendChild(activeYN);
    gridOD3.appendChild(pdfWillOnlyTgle);

    // ================================================
    // PERSONAL DETAILS
    const personalDetailHeading = U.divAtt('h6', 'class', 'mt-3');
    personalDetailHeading.innerHTML = 'Personal detail: ';
    grid1.appendChild(personalDetailHeading);

    const gridPD = U.divAtt('div', 'class', 'res-grid-cols-3');
    const titleDD = await comp.select_v2({elID: 'title', ddData: this.titleData, valueDataName: 'title_uuid', textDataName: 'short_text', labelName: 'Title', requiredYN: 1});
    const f_name = await comp.inputText(`f_name`, '', 'Full names', 1);
    const s_name = await comp.inputText(`s_name`, '', 'Surname', 1);
    const IDpass = await comp.inputIDPassport('IDpass', true, '', 1, 'dob');
    const emailInput = await comp.inputEmail('email_address', '', 'Email', 1);
    const mobInput = await comp.inputTel('cell_nr', '', 'Mobile number', 1);
    const textarera = await comp.textarea('textarea', '', 'Notes', 0);
    gridPD.appendChild(titleDD);
    gridPD.appendChild(f_name);
    gridPD.appendChild(s_name);
    gridPD.appendChild(IDpass);
    gridPD.appendChild(emailInput);
    gridPD.appendChild(mobInput);
    gridPD.appendChild(textarera);

    grid1.appendChild(gridOD3);
    grid1.appendChild(companyDiv);
    grid1.appendChild(advisorDiv);
    grid1.appendChild(supportDiv);
    grid1.appendChild(gridPD);

    newUser.appendChild(grid1);
  },

  async buildCompanySection() {
    const grid1 = U.id('companyDiv');
    grid1.innerHTML = '';
    // ================================================
    // COMPANY EMPLOYEE
    const companyHeading = U.divAtt('h6', 'class', 'mt-3');
    companyHeading.innerHTML = 'Office Employee: ';
    grid1.appendChild(companyHeading);

    const gridOE = U.divAtt('div', 'class', 'res-grid-cols-2');
    const divBranch = U.divAtt('div', 'id', 'divBranch');
    const divisionDD = await comp.select_v2({elID: 'companyDD', ddData: this.divisionsData, valueDataName: 'division_uuid', textDataName: 'short_text', labelName: 'Company', requiredYN: 1, onchange: 'thsPage.showCompanyBranch()'});
    gridOE.appendChild(divisionDD);
    gridOE.appendChild(divBranch);
    grid1.appendChild(gridOE);
  },

  async showCompanyBranch() {
    const companyDD = U.id('companyDD').value;
    const grid1 = U.id('divBranch');
    grid1.innerHTML = '';

    if (!companyDD) {
      return;
    }

    const filteredData = this.divBranchesData.filter((division) => division.division_uuid === companyDD);

    const compBranchDD = await comp.select_v2({elID: 'compBranchDD', ddData: filteredData, valueDataName: 'division_branch_uuid', textDataName: 'short_text', labelName: 'Employee company branch', requiredYN: 1});
    grid1.appendChild(compBranchDD);
  },

  async buildCompanySectionPlus() {
    const grid1 = U.id('companyDiv');
    grid1.innerHTML = '';
    // ================================================
    // COMPANY EMPLOYEE
    const companyHeading = U.divAtt('h6', 'class', 'mt-3');
    companyHeading.innerHTML = 'Office Employee: ';
    grid1.appendChild(companyHeading);

    const gridOE = U.divAtt('div', 'class', 'res-grid-cols-2');
    const gridOS = U.divAtt('div', 'class', 'res-grid-cols-2');
    gridOS.id = 'orgSectionDiv';
    const divBranch = U.divAtt('div', 'id', 'divBranch');
    const divisionDD = await comp.select_v2({elID: 'companyDD', ddData: this.divisionsData, valueDataName: 'division_uuid', textDataName: 'short_text', labelName: 'Company', requiredYN: 1, onchange: 'thsPage.showCompanyBranchPlus()'});
    gridOE.appendChild(divisionDD);
    gridOE.appendChild(divBranch);
    grid1.appendChild(gridOE);
    grid1.appendChild(gridOS);
  },

  async showCompanyBranchPlus() {
    const companyDD = U.id('companyDD').value;
    const grid1 = U.id('divBranch');
    grid1.innerHTML = '';
    const grid2 = U.id('orgSectionDiv');
    grid2.innerHTML = '';

    if (!companyDD) {
      return;
    }

    const orgDiv = U.divAtt('div', 'id', 'orgDiv');

    const filteredData = this.divBranchesData.filter((division) => division.division_uuid === companyDD);

    const compBranchDD = await comp.select_v2({elID: 'compBranchDD', ddData: filteredData, valueDataName: 'division_branch_uuid', textDataName: 'short_text', labelName: 'Employee company branch', requiredYN: 1, onchange: 'thsPage.showOrg()'});
    grid1.appendChild(compBranchDD);
    grid1.appendChild(orgDiv);
  },

  async showOrg() {
    const compBranchDD = U.id('compBranchDD').value;
    const grid1 = U.id('orgSectionDiv');
    grid1.innerHTML = '';

    if (!compBranchDD) {
      return;
    }

    const orgBranchDiv = U.divAtt('div', 'id', 'orgBranchDiv');

    const filteredData = this.orgBranchesData.filter((org) => org.division_branch_uuid === compBranchDD);
    const orgDD = await comp.select_v2({elID: 'orgDD', ddData: filteredData, valueDataName: 'org_uuid', textDataName: 'short_text', labelName: 'Organisation', requiredYN: 1, onchange: 'thsPage.showOrgBranches()'});

    grid1.appendChild(orgDD);
    grid1.appendChild(orgBranchDiv);
  },

  async showOrgBranches() {
    const orgDD = U.id('orgDD').value;
    const grid1 = U.id('orgBranchDiv');
    grid1.innerHTML = '';

    if (!orgDD) {
      return;
    }

    const filteredData = this.orgBranchesData.filter((org) => org.org_uuid === orgDD);
    const orgBranchDD = await comp.select_v2({elID: 'orgBranchDD', ddData: filteredData, valueDataName: 'org_branch_uuid', textDataName: 'short_text', labelName: 'Organisation branch', requiredYN: 1, onchange: 'thsPage.buildSupportSection()'});

    grid1.appendChild(orgBranchDD);
  },

  async buildAdvisorSection() {
    const grid1 = U.id('advisorDiv');
    grid1.innerHTML = '';

    // ================================================
    // ADVISOR
    const advisorHeading = U.divAtt('h6', 'class', 'mt-3');
    advisorHeading.innerHTML = 'Advisor: ';
    grid1.appendChild(advisorHeading);

    const gridA1 = U.divAtt('div', 'class', 'res-grid-cols-3');
    const brokerNumber = await comp.inputText('brokerNumber', '', 'Broker Number', 1);

    gridA1.appendChild(brokerNumber);
    grid1.appendChild(gridA1);
  },

  async buildSupportSection() {
    const grid1 = U.id('supportDiv');
    grid1.innerHTML = '';
    const roleSelect = U.id('roleSelect');
    if (roleSelect.options[roleSelect.selectedIndex].text !== 'Support') {
      return;
    }

    const orgBranchDD = U.id('orgBranchDD').value;

    if (!orgBranchDD) {
      return;
    }
    // ================================================
    // ADVISOR
    const advisorHeading = U.divAtt('h6', 'class', 'mt-3');
    grid1.appendChild(advisorHeading);

    const gridA1 = U.divAtt('div', 'class', 'res-grid-cols-3');
    const filteredData = this.advisorList.filter((advisor) => advisor.org_branch_uuid === orgBranchDD);
    const advisorDD = await comp.select_v2({elID: 'advisorDD', ddData: filteredData, valueDataName: 'user_uuid', textDataName: 'c_name', labelName: 'Advisor', requiredYN: 1});

    gridA1.appendChild(advisorDD);
    grid1.appendChild(gridA1);
  },

  async configForm() {
    const roleSelect = U.id('roleSelect');

    switch (roleSelect.options[roleSelect.selectedIndex].text) {
      case 'Marketer':
        await this.buildMainPage({pdfWillOnly: 0});
        // await this.buildCompanySection();
        break;
      case 'Admin':
        await this.buildMainPage({pdfWillOnly: 1});
        // await this.buildCompanySection();
        break;
      case 'Advisor':
      case 'Associate Advisor':
        await this.buildMainPage({pdfWillOnly: 0});
        // await this.buildCompanySectionPlus();
        await this.buildAdvisorSection();
        break;
      case 'Support':
        await this.buildMainPage({pdfWillOnly: 0});
        // await this.buildCompanySectionPlus();
        break;
      case 'Business development':
        await this.buildMainPage({pdfWillOnly: 0});
        break;
      default:
        const newUser = U.id('mainDiv');
        if (newUser) newUser.innerHTML = '';
    }
  },

  async addUser() {
    if (!(await U.validateForm('user-form'))) {
      return;
    }

    const vars = {};

    const roleSelect = U.id('roleSelect');

    // Office Details
    vars.role = U.id('roleSelect').value;
    vars.active = U.id('ativeYN').checked;
    vars.pdfWillOnly = U.id('pdfWillOnly').checked;

    // Personal Details - REQUIRED
    vars.title = U.id('title').value;
    vars.fullName = U.id('f_name').value;
    vars.surname = U.id('s_name').value;
    vars.idNumber = U.id('IDpass_toggle').checked ? U.id('IDpass').value : null;
    vars.ppNumber = U.id('IDpass_toggle').checked ? null : U.id('IDpass').value;

    vars.email = U.id('email_address').value;
    vars.mobile = U.id('cell_nr').value;
    vars.notes = U.id('textarea').value;

    switch (roleSelect.options[roleSelect.selectedIndex].text) {
      // case 'Marketer':
      //   vars.company = U.id('companyDD') ? U.id('companyDD').value : null;
      //   vars.employeeCompanyBranch = U.id('compBranchDD') ? U.id('compBranchDD').value : null;
      //   break;
      // case 'Admin':
      //   vars.company = U.id('companyDD') ? U.id('companyDD').value : null;
      //   vars.employeeCompanyBranch = U.id('compBranchDD') ? U.id('compBranchDD').value : null;
      //   break;
      case 'Advisor':
      case 'Associate Advisor':
        // vars.orgBranch = U.id('orgBranchDD').value;
        vars.brokerNumber = U.id('brokerNumber').value;
        break;
      // case 'Support':
      //   vars.advisor_uuid = U.id('advisorDD').value;
      //   break;
    }

    O.PREP([await O.mPOST('users/ins-user', vars)])
      .then(async (res) => {
        const msg = res['users/ins-user'].status;
        comp.toast(msg);
        this.render();
      })
      .catch(() => {});
  },
};
